import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Reviews from 'components/VDP/Reviews'
import useReviews from 'hooks/useReviews'
import sx from './styles'

const UserGoogleReviews = (variant = 'column') => {
  const googleReviews = useReviews()
  const sortByMax = (a, b) => b.rating - a.rating

  const heightRewiew = variant === 'column'
    ? sx.columnReviewHeight
    : sx.rowReviewHeight

  return (
    <Box sx={{ ...sx.reviewsContainer, ...heightRewiew }}>
      {googleReviews?.reviews && (
        googleReviews?.reviews
          .filter((i) => !(`${i?.text}`.toLowerCase().includes('satélite')))
          .sort(sortByMax)
          .map((review, index) => (
            <Reviews
              item={review}
              key={index}
            />
          ))
      )}
    </Box>
  )
}

export default memo(UserGoogleReviews)
